module.exports = __webpack_public_path__ + "static/media/signin-background.d5b210ec.png";